import isMobileDevice from './isMobileDevice';
export default function calculateRootMargin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      marginPercent = _ref.marginPercent,
      mobileScaling = _ref.mobileScaling;

  if (!marginPercent) {
    return undefined;
  }

  var finalMarginPercent = isMobileDevice() && mobileScaling !== undefined && mobileScaling !== -1 ? marginPercent * mobileScaling : marginPercent;
  return "".concat(finalMarginPercent / 100 * window.innerHeight, "px");
}